import { RevenueSkeleton } from "components/PortalLoading";
import { useState } from 'react';
import { FiBarChart2, FiChevronDown, FiDownload } from 'react-icons/fi';
import { saveAs } from 'file-saver';
import RevenueCurrencyDetails from './RevenueCurrencyDetails';
import RevenueCurrencyTable from './RevenueCurrencyTable';
import { getRevenueRows, revenueCsv } from './revenueData';
import './revenueReport.css';

export default function CurrencyRevenueReport({ data, publisher = false, isLoading, isError, retry, period = {}, compact = false }) {
    const [selectedCode, setSelectedCode] = useState('');
    const [expanded, setExpanded] = useState(!compact);
    const rows = getRevenueRows(data, publisher);
    const activeRows = rows.filter((row) => row.hasActivity);
    const selected = rows.find((row) => row.currency.code === selectedCode) || activeRows[0] || rows[0];

    if (isLoading) return <RevenueSkeleton compact={compact} publisher={publisher} />;
    if (isError) return <div className="revenue-state revenue-error" role="alert">
        <strong>Unable to load revenue.</strong><p>Please try again to see the latest figures.</p>
        {retry && <button type="button" onClick={() => retry()} className="revenue-button">Retry</button>}
    </div>;
    if (!activeRows.length) return <div className="revenue-state revenue-empty" role="status">
        <FiBarChart2 aria-hidden="true" /><h3>No revenue recorded for this period</h3>
        <p>Try a wider date range or choose All time to see earlier activity.</p>
    </div>;

    const exportSummary = () => {
        saveAs(new Blob(['\uFEFF', revenueCsv(rows, publisher, period)], { type: 'text/csv;charset=utf-8' }),
            `${publisher ? 'publisher-earnings' : 'revenue'}-${period.from || 'all'}-${period.to || 'time'}.csv`);
    };
    return <div className="revenue-content">
        <div className="revenue-currency-toolbar">
            <div><span className="revenue-eyebrow">Currency breakdown</span><p>Amounts are shown in their recorded currencies.</p></div>
            <label className="revenue-field revenue-currency-select">Reporting currency
                <select value={selected.currency.code} onChange={(event) => setSelectedCode(event.target.value)}>
                    {rows.map(({ currency }) => <option key={currency.code} value={currency.code}>
                        {currency.code}{currency.label && currency.label !== currency.code ? ` · ${currency.label}` : ''}
                    </option>)}
                </select>
            </label>
        </div>
        <RevenueCurrencyDetails row={selected} publisher={publisher} />
        <div className="revenue-overview">
            <div className="revenue-overview-header">
                <div><h3>All currencies</h3><p>{activeRows.length} {activeRows.length === 1 ? 'currency with' : 'currencies with'} activity in this period</p></div>
                <div className="portal-revenue-actions"><button type="button" className="revenue-button" onClick={exportSummary}><FiDownload aria-hidden="true" /> Export CSV</button>{compact && <button type="button" className="portal-report-toggle" aria-label={expanded ? "Collapse currency table" : "Expand currency table"} aria-expanded={expanded} aria-controls="portal-revenue-currency-table" onClick={() => setExpanded((value) => !value)}><FiChevronDown aria-hidden="true" /></button>}</div>
            </div>
            <div id={compact ? "portal-revenue-currency-table" : undefined} hidden={compact && !expanded}><RevenueCurrencyTable rows={rows} publisher={publisher} selectedCode={selected.currency.code} onSelect={setSelectedCode} /></div>
        </div>
    </div>;
}
